import _ from 'lodash';

export const createPrefixOptions = (rolePayload) => {
  return _.filter(
    _.uniqBy(
      _.map(rolePayload, (role) => {
        return {
          text: role.key,
          value: role.value,
        };
      }),
      'text'
    ),
    (role) => {
      return role.value !== null;
    }
  );
};
